import { applySpec, inc, mapObjIndexed, mergeRight, pipe, prop, propEq, propOr } from "ramda";
import { COMPARATOR, IFilterDefaultValue, IFilterState } from "taltech-styleguide";
import { isUndefined } from "ramda-adjunct";
import { QueryState, operatorMapper } from "@components-common/types";

export const isRemoteSource = propEq("REMOTE", "type");
export const isMemorySource = propEq("MEMORY", "type");

const mapOperator = (comparator: COMPARATOR|undefined) => isUndefined(comparator) ? undefined : operatorMapper[comparator!]


export const mapQuery = (query: QueryState) => {
  const defaultQuery = { page: 0, sizePerPage: 10, sortField: undefined, sortOrder: undefined };
  const filter = []
  const filledQuery = mergeRight(defaultQuery, query);

  const convertedQuery = {...applySpec<QueryState>({
    page: (x:QueryState) => (prop("page",x) || 0) + 1,
    size: prop("sizePerPage"),
    sortBy: prop("sortField"),
    sortDirection: prop("sortOrder"),
  })(filledQuery),
  ...mapFilters(filledQuery)
  };
  return convertedQuery;
}
export const convertFilterToQueryString = (
  property: string,
  filter?: IFilterState<IFilterDefaultValue>
) => {
  return `${property}${mapOperator(filter?.comparator!)}${
    filter?.filterVal
  }`;
};

// export const convertFilters = (state?: QueryState) => {
//   let result: IKeyedObject<string> = {};
//   if (isUndefined(state?.filters)) {
//     const { filters } = state!;
//     Object.keys(filters!).forEach((x) => {
//       result[x] = (filters! as any)[x].filterVal as string;
//     });
//   }
//   return result;
// };
export const mapFilters = (state = {}) => {
  return pipe(
    propOr({}, 'filters'),
    mapObjIndexed((filter) => prop('filterVal', filter as any))
  )(state);
};
